// extracted by mini-css-extract-plugin
export var paginationContainer = "_4h-0";